'use strict'

angular
	.module('widget')
	.factory('twReservationManager', function twReservationManagerFactory(dataFactory, tgClock) {
		/**
		 * START: Shared code between all apps
		 */

		var reservationSettings = {}
		var scheduleBlocksByDay = {}
		var sectionsObj = {}
		var minReservationAntecedence = 60
		var reservationAntecedence = 30
		var venueTz = 'America/Sao_Paulo'
		var dbDateTz = 'America/Sao_Paulo'

		function startReservationSettings(_settings, _venueTz, _dbDateTz) {
			sectionsObj = {}
			scheduleBlocksByDay = {}

			if (_venueTz) venueTz = _venueTz
			if (_dbDateTz) dbDateTz = _dbDateTz
			if (_settings.minReservationAntecedence) {
				minReservationAntecedence = _settings.minReservationAntecedence
			}
			if (_settings.reservationAntecedence) {
				reservationAntecedence = _settings.reservationAntecedence
			}
			_.map(_settings.venueSections, function (_section) {
				sectionsObj[_section._id] = _section
			})
			_.map(_settings.sectionSchedules, function (_schedule) {
				if (_schedule.section && _.has(sectionsObj, _schedule.section)) {
					sectionsObj[_schedule.section].schedules = _schedule.schedules
					sectionsObj[_schedule.section].scheduleBlocks = _schedule.scheduleBlocks
					sectionsObj[_schedule.section].extraSchedules = _schedule.extraSchedules
					if (_schedule.scheduleBlocks && _schedule.scheduleBlocks.length > 0) {
						_.map(_schedule.scheduleBlocks, function (block) {
							if (!scheduleBlocksByDay[_schedule.section]) {
								scheduleBlocksByDay[_schedule.section] = {}
							}
							var blockDateString = moment.tz(block.day, dbDateTz).format('YYYY-MM-DD')
							if (!scheduleBlocksByDay[_schedule.section][blockDateString]) {
								scheduleBlocksByDay[_schedule.section][blockDateString] = true
							}
						})
					}
				}
			})
			_.map(_settings.bookingApps, function (_app) {
				if (_.get(_app, 'section') && _.get(_app, 'app') && _.has(sectionsObj, _app.section)) {
					sectionsObj[_app.section][_app.app._id] = _app.schedules
				}
			})
		}

		function findCapacityGroup(_section, _partySize) {
			if (_section && _partySize) {
				var section = _.cloneDeep(sectionsObj[_section])
				var capacityArray = _.sortBy(section.capacityGroups, function (obj) {
					return obj.min
				})
				var acs = capacityArray.length
				for (var i = 0; i < acs; i++) {
					if (_partySize >= capacityArray[i].min && _partySize <= capacityArray[i].max) {
						return capacityArray[i]
					}
				}
			}
		}

		function getNewStatus(_query, _callback) {
			var queryData = { venueId: reservationSettings.venue, search: 'all' }
			if (_query.date) {
				queryData.year = _query.date.format('YYYY') - 0
				queryData.month = _query.date.format('MM') - 0
				queryData.day = _query.date.format('DD') - 0
			} else if (_query.startDate && _query.endDate) {
				queryData.startDate = _query.startDate.format()
				queryData.endDate = _query.endDate.format()
			}
			if (_query.section) {
				queryData.section = _query.section
			}
			if (_query.origin) {
				queryData.origin = _query.origin
			}
			if (_query.partySize) {
				queryData.partySize = _query.partySize
			}
			return getBooking(queryData, _callback)
		}

		function createTimeRange(_startHour, _startMinute, _endHour, _endMinute) {
			var timeArray = []
			var _start = _.isNumber(_startHour) && _.isNumber(_startMinute) ? _startHour * 60 + _startMinute : 0
			var _end = _.isNumber(_endHour) && _.isNumber(_endMinute) ? _endHour * 60 + _endMinute : 24 * 60
			var _minuteInterval = reservationSettings.reservationInterval //minutes interval
			var tt = _start // start time
			//var ap = ['AM', 'PM']; // AM-PM
			//loop to increment the time and push results in array
			for (var i = 0; tt <= _end; i++) {
				var hh = Math.floor(tt / 60) // getting hours of day in 0-24 format
				var mm = tt % 60 // getting minutes of the hour in 0-55 format
				var HH = hh < 10 ? '0' + hh : hh
				//("0" + (hh % 12)).slice(-2) //formato hora AM-PM
				//calculo ap = ap[Math.floor(hh/12)]
				timeArray.push(HH + ':' + ('0' + mm).slice(-2))
				tt = tt + _minuteInterval
			}
			return _.uniq(timeArray)
		}

		function isTimestampBlocked(date, section, time) {
			if (!sectionsObj[section].scheduleBlocks || sectionsObj[section].scheduleBlocks.length == 0) {
				return false
			}

			return _.some(sectionsObj[section].scheduleBlocks, function (block) {
				var blockDate = moment.tz(block.day, dbDateTz)
				if (
					blockDate.format('YYYY-MM-DD') == date.format('YYYY-MM-DD') &&
					block.start <= time &&
					time <= block.end
				) {
					return true
				}
			})
		}

		function isTimestampRespectingAntecedence(date, time) {
			var reservationTimestamp = moment.tz(date.format('YYYY-MM-DD') + ' ' + time, venueTz)
			var now = getNow()
			if (!now) {
				return false
			}
			var reserveNow = moment(now)
			var timeDiffMinutes = reservationTimestamp.diff(reserveNow, 'minutes')
			var timeDiffDays = reservationTimestamp.diff(reserveNow, 'days')
			if (timeDiffMinutes >= minReservationAntecedence && timeDiffDays <= reservationAntecedence) {
				return true
			}

			return false
		}

		function isTimestampAvailable(date, section, time, bypassBlocks, bypassAntecedence) {
			var blocked = false
			if (!bypassBlocks) {
				blocked = isTimestampBlocked(date, section, time)
			}

			var respectsAntecedence = true
			if (!bypassAntecedence) {
				respectsAntecedence = isTimestampRespectingAntecedence(date, time)
			}

			return !blocked && respectsAntecedence
		}

		function isTimestampOnExtraSchedules(date, section, time, app) {
			if (!sectionsObj[section].extraSchedules || sectionsObj[section].extraSchedules.length == 0)
				return false

			return _.some(sectionsObj[section].extraSchedules, function (extraSchedule) {
				var extraScheduleDate = moment.tz(extraSchedule.day, dbDateTz)
				if (!extraScheduleDate.isSame(date)) return false
				if (app != (extraSchedule.origin.app || extraSchedule.origin.label)) return false
				if (extraSchedule.start > time || extraSchedule.end < time) return false

				return true
			})
		}

		/**
		 * The origins Phone and Widget are related to all sections, just check for the bookingApps
		 */
		function isAppRelatedToSection(_app, _section) {
			if (!_app || (findAppLabel(_app) != '' && !_.has(sectionsObj[_section], _app))) {
				return false
			}

			return true
		}

		function normalizeExtraSchedule(_time, _extraSchedules, _schedule, _app) {
			var sectionSchedule = _.find(_extraSchedules, function (schedule) {
				return schedule.origin.label == 'Phone' && schedule.start <= _time && schedule.end >= _time
			})

			if (sectionSchedule) {
				//The copy is necessary so it does not mess with the extra schedules original array
				var scheduleCopy = angular.copy(sectionSchedule)
				scheduleCopy.seats = _schedule.seats
				return scheduleCopy
			}

			return null
		}

		function addNewTimeOption(_time, _schedule, _timeOptions, _app, _extraSchedules, _schedulesAdded) {
			if (_app != 'Phone' && !_schedule.parentSchedule) {
				//Normalize schedule id with the Phone one, not the app specific
				var sectionSchedule = normalizeExtraSchedule(_time, _extraSchedules, _schedule, _app)

				if (sectionSchedule) {
					_timeOptions.push({
						time: _time,
						scheduleId: sectionSchedule.parentSchedule || sectionSchedule._id,
					})
					_schedulesAdded.push(sectionSchedule)
				}

				return
			}

			var scheduleId = _schedule.parentSchedule || _schedule._id
			_timeOptions.push({
				time: _time,
				scheduleId: scheduleId,
			})
			_schedulesAdded.push(_schedule)
		}

		function replaceTimeOption(
			_time,
			_schedule,
			_rangesSeats,
			_timeOptions,
			_recurringTime,
			_app,
			_extraSchedules,
			_schedulesAdded,
			_schedulesWithReplacedTimes
		) {
			var sectionSchedule = null
			if (_app != 'Phone' && !_schedule.parentSchedule) {
				//Normalize schedule id with the Phone one, not the app specific
				sectionSchedule = normalizeExtraSchedule(_time, _extraSchedules, _schedule, _app)
				if (!sectionSchedule) {
					return null
				}
			}

			//Remove seats corresponding to this time from the range total seats
			_.map(Object.keys(_rangesSeats), function (scheduleId) {
				if (scheduleId == _recurringTime.scheduleId) {
					_rangesSeats[scheduleId] -= _recurringTime.seatsAddedToSchedule
						? _recurringTime.seatsAddedToSchedule
						: 0
				}
			})

			var scheduleId = sectionSchedule
				? sectionSchedule.parentSchedule || sectionSchedule._id
				: _schedule.parentSchedule || _schedule._id
			_.each(_timeOptions, function (option) {
				if (option.time == _time) {
					delete option.seatsAddedToSchedule
					option.scheduleId = scheduleId
					return false //Stops the loop
				}
			})

			_schedulesWithReplacedTimes.push(_recurringTime.scheduleId)
			_schedulesAdded.push(sectionSchedule || _schedule)
		}

		function updateRangesAndSeats(_rangesSeats, _ranges, _schedulesAdded) {
			if (_schedulesAdded && _schedulesAdded.length > 0) {
				_.map(_schedulesAdded, function (schedule) {
					var scheduleId = schedule.parentSchedule || schedule._id
					var seats = schedule.seats ? schedule.seats : 0
					_rangesSeats[scheduleId] = _rangesSeats[scheduleId] ? _rangesSeats[scheduleId] + seats : seats
					_ranges[scheduleId] = scheduleId
				})
			}
		}

		function removeEmptyRanges(_rangesSeats, _ranges, _timeOptions, _schedulesWithReplacedTimes) {
			if (_schedulesWithReplacedTimes && _schedulesWithReplacedTimes.length > 0) {
				_.map(_schedulesWithReplacedTimes, function (scheduleId) {
					var scheduleStillExists = _.some(_timeOptions, { scheduleId: scheduleId })
					if (!scheduleStillExists) {
						delete _rangesSeats[scheduleId]
						delete _ranges[scheduleId]
					}
				})
			}
		}

		function merge(_rangesSeats, _timeOptions, _ranges, _extraSchedules, _app) {
			var schedulesAdded = []
			var schedulesWithReplacedTimes = []

			_.map(_extraSchedules, function (schedule) {
				if (_app == (schedule.origin.app || schedule.origin.label)) {
					var startTimeObj = schedule.start.split(':')
					var endTimeObj = schedule.end.split(':')
					var timeRange = createTimeRange(
						parseInt(startTimeObj[0]),
						parseInt(startTimeObj[1]),
						parseInt(endTimeObj[0]),
						parseInt(endTimeObj[1])
					)
					_.map(timeRange, function (time) {
						var recurringTime = _.find(_timeOptions, { time: time })
						if (!recurringTime) {
							addNewTimeOption(time, schedule, _timeOptions, _app, _extraSchedules, schedulesAdded)
						} else {
							replaceTimeOption(
								time,
								schedule,
								_rangesSeats,
								_timeOptions,
								recurringTime,
								_app,
								_extraSchedules,
								schedulesAdded,
								schedulesWithReplacedTimes
							)
						}
					})
				}
			})

			updateRangesAndSeats(_rangesSeats, _ranges, _.uniqBy(schedulesAdded, '_id'))
			removeEmptyRanges(_rangesSeats, _ranges, _timeOptions, _.uniq(schedulesWithReplacedTimes))
		}

		function getTimeRanges(_date, _section, _app, _isBookingApp, _bypassBlocks, _bypassAntecedence) {
			var weekDay = _date.weekday() == 0 ? 7 : _date.weekday()
			var allSchedules = _isBookingApp ? sectionsObj[_section][_app] : sectionsObj[_section].schedules
			var daySchedules = _.filter(allSchedules, { day: weekDay })

			var sectionDaySchedules = null
			if (_isBookingApp) {
				sectionDaySchedules = _.filter(sectionsObj[_section].schedules, { day: weekDay })
			}

			var timeRangesSeats = {}
			var timeRangesOptions = []
			var timeRanges = {}

			if (daySchedules && daySchedules.length > 0) {
				_.map(daySchedules, function (schedule) {
					var startTimeObj = schedule.start.split(':')
					var endTimeObj = schedule.end.split(':')
					var timeRange = createTimeRange(
						parseInt(startTimeObj[0]),
						parseInt(startTimeObj[1]),
						parseInt(endTimeObj[0]),
						parseInt(endTimeObj[1])
					)
					_.map(timeRange, function (time) {
						var scheduleId = schedule._id
						if (_isBookingApp) {
							//Normalize schedule id with the section one, not the app specific
							var sectionSchedule = _.find(sectionDaySchedules, function (schedule) {
								return schedule.start <= time && schedule.end >= time
							})
							if (sectionSchedule) {
								scheduleId = sectionSchedule._id
							} else {
								scheduleId = null
							}
						}

						//Checks if the time is valid within the section hours
						if (scheduleId) {
							var seatsAddedToSchedule = null

							//Only includes the seats if the timestamp is available
							if (isTimestampAvailable(_date, _section, time, _bypassBlocks, _bypassAntecedence)) {
								seatsAddedToSchedule = schedule.seats
								if (timeRangesSeats[scheduleId]) {
									timeRangesSeats[scheduleId] += seatsAddedToSchedule
								} else {
									timeRangesSeats[scheduleId] = seatsAddedToSchedule
								}
							}
							timeRanges[scheduleId] = scheduleId

							timeRangesOptions.push({
								time: time,
								scheduleId: scheduleId,
								seatsAddedToSchedule: seatsAddedToSchedule,
							})
						}
					})
				})
			}

			if (sectionsObj[_section].extraSchedules && sectionsObj[_section].extraSchedules.length > 0) {
				var dayExtraSchedules = _.filter(sectionsObj[_section].extraSchedules, function (extraSchedule) {
					var extraScheduleDate = moment.tz(extraSchedule.day, dbDateTz)
					if (extraScheduleDate.format('YYYY-MM-DD') == _date.format('YYYY-MM-DD')) {
						return true
					}
					return false
				})

				if (dayExtraSchedules && dayExtraSchedules.length > 0) {
					merge(timeRangesSeats, timeRangesOptions, timeRanges, dayExtraSchedules, _app)
				}
			}

			if (_.size(timeRangesOptions) == 0) {
				return null
			}

			return {
				timeRangesSeats: timeRangesSeats,
				timeRangesOptions: timeRangesOptions,
				timeRanges: timeRanges,
			}
		}

		function getSectionById(_id) {
			var section = []
			_.map(reservationSettings.venueSections, function (_section) {
				if (_section._id == _id) {
					section.push(_section)
				}
			})
			if (section && section.length > 0) {
				return section[0]
			} else {
				return null
			}
		}

		/**
		 * Search on bookingApps, doest not consider default origins Phone and Widget
		 */
		function findAppLabel(_id) {
			var label = ''
			_.map(reservationSettings.bookingApps, function (_elem) {
				if (_elem.app._id == _id) {
					label = _elem.app.label
				}
			})
			return label
		}

		function appsOptions() {
			var optionsArray = []
			optionsArray.push({ name: 'Telefone', value: 'Phone' })
			optionsArray.push({ name: 'Widget', value: 'Widget' })
			_.map(_.uniqBy(reservationSettings.bookingApps, 'app._id'), function (_elem) {
				if (_.get(_elem, 'app')) {
					optionsArray.push({ name: _elem.app.label, value: _elem.app._id })
				}
			})
			return optionsArray
		}

		function sectionReservationLimit(_date, _app, _section, _callback) {
			var capacityArray = []
			var capacityGroup = _.cloneDeep(sectionsObj[_section].capacityGroups)
			var capacityGroupObj = {}

			_.map(capacityGroup, function (_capacity) {
				capacityGroupObj[_capacity._id] = _.cloneDeep(_capacity)
			})
			_.map(capacityGroupObj, function (_capacityObj) {
				for (var i = _capacityObj.min; i <= _capacityObj.max; i++) {
					capacityArray.push({ value: i })
				}
			})
			capacityArray = _.sortBy(capacityArray, function (obj) {
				return obj.value
			})
			return _callback(false, capacityArray)
		}

		function hashCapacityGroupsByTimeRanges(_section, _timeRanges) {
			var hash = {}
			_.map(sectionsObj[_section].capacityGroups, function (group) {
				hash[group._id] = {}
				_.map(Object.keys(_timeRanges), function (timeRange) {
					hash[group._id][timeRange] = group.quantity
				})
			})
			return hash
		}

		function updateTimeRangesFreeSeats(_freeSeats, _timeOptions, _usage, _capacityGroup) {
			if (_timeOptions.length > 0) {
				var schedule = _.find(_timeOptions, { time: _usage.reservationTime })
				if (!schedule) {
					//Reservation time does not fit the configured schedules for this origin, skips
					return null
				}
				var scheduleId = schedule.scheduleId
				if (_freeSeats[scheduleId]) {
					_freeSeats[scheduleId] -= _usage.count * (_capacityGroup ? _capacityGroup.max : _usage.partySize)
				}
			}
		}

		function updateCapacityGroupsTimeRangesFreeSeats(_freeSeats, _timeOptions, _usage, _capacityGroup) {
			if (_timeOptions.length > 0 && _capacityGroup) {
				var schedule = _.find(_timeOptions, { time: _usage.reservationTime })
				if (!schedule) {
					//Reservation time does not fit the configured schedules for this origin, skips
					return null
				}
				var scheduleId = schedule.scheduleId
				if (_freeSeats[_capacityGroup._id] && _freeSeats[_capacityGroup._id][scheduleId]) {
					_freeSeats[_capacityGroup._id][scheduleId] -= _usage.count
				}
			}
		}

		function updateFreeSeatsPerspectives(
			_sectionSeats,
			_sectionTimeOptions,
			_thisSeats,
			_thisSeatsTimeOptions,
			_groupsSeats,
			_groupsTimeOptions,
			_usage,
			_group,
			_appLabel,
			_app
		) {
			updateTimeRangesFreeSeats(_sectionSeats, _sectionTimeOptions, _usage, _group)
			if ((_app == 'Widget' && _usage.origin == 'Widget') || (_appLabel && _appLabel == _usage.origin)) {
				updateTimeRangesFreeSeats(_thisSeats, _thisSeatsTimeOptions, _usage, _group)
			}
			if (_groupsSeats) {
				updateCapacityGroupsTimeRangesFreeSeats(_groupsSeats, _groupsTimeOptions, _usage, _group)
			}
		}

		function getSectionOptionItem(_sectionRanges, _section, _type) {
			var sectionFreeSeats = 0
			if (_sectionRanges.sectionTimeRanges && _.size(_sectionRanges.sectionTimeRanges.timeRangesSeats) > 0) {
				_.map(_sectionRanges.sectionTimeRanges.timeRangesSeats, function (freeSeats, range) {
					sectionFreeSeats += freeSeats
				})
			}
			var freeSeatsPerspectives = [sectionFreeSeats]

			if ((_sectionRanges.app != 'Phone' && !_sectionRanges.appLabel) || _sectionRanges.appLabel) {
				var appFreeSeats = 0
				_.map(_sectionRanges.timeRanges.timeRangesSeats, function (freeSeats, range) {
					appFreeSeats += freeSeats
				})
				freeSeatsPerspectives.push(appFreeSeats)
			}

			//For group reservations, the capacity groups seats are not considered
			if (!_type || _type == 'Regular') {
				if (_sectionRanges.capacityGroupsFreeSeats && _.size(_sectionRanges.capacityGroupsFreeSeats) > 0) {
					var groupsFreeSeats = 0
					_.map(_sectionRanges.capacityGroupsFreeSeats, function (freeTablesByInterval, group) {
						_.map(freeTablesByInterval, function (freeTables, range) {
							groupsFreeSeats += freeTables * _.find(sectionsObj[_section].capacityGroups, { _id: group }).max
						})
					})
					freeSeatsPerspectives.push(groupsFreeSeats)
				} else {
					//No capacity groups set for this section
					freeSeatsPerspectives.push(0)
				}
			}

			var freeSeats = Math.min.apply(Math, freeSeatsPerspectives)
			return { value: _section, freeSeats: freeSeats, label: sectionsObj[_section].label }
		}

		function getUpdatedSectionOptions(_sectionsTimeRanges, _type) {
			var options = []
			if (_sectionsTimeRanges && Object.keys(_sectionsTimeRanges).length > 0) {
				options = _.map(_sectionsTimeRanges, function (sectionRanges, section) {
					return getSectionOptionItem(sectionRanges, section, _type)
				})
			}
			return options
		}

		function getUpdatedDayRangeOptions(_daysTimeRanges, _type) {
			var options = []

			if (_daysTimeRanges && Object.keys(_daysTimeRanges).length > 0) {
				_.each(_daysTimeRanges, function (sectionsTimeRanges, day) {
					var freeSeats = 0
					_.each(sectionsTimeRanges, function (sectionRanges, section) {
						var sectionOptionItem = getSectionOptionItem(sectionRanges, section, _type)
						freeSeats += sectionOptionItem ? sectionOptionItem.freeSeats : 0
					})
					options.push({ day: day, freeSeats: freeSeats })
				})
			}

			return options
		}

		function getSectionDayTimeRanges(_section, _date, _app, _type, _bypassBlocks, _bypassAntecedence) {
			if (isAppRelatedToSection(_app, _section)) {
				var isBookingApp = _.has(sectionsObj[_section], _app) ? true : false
				var appLabel = isBookingApp ? findAppLabel(_app) : null
				var timeRanges = getTimeRanges(_date, _section, _app, isBookingApp, _bypassBlocks, _bypassAntecedence)
				var sectionTimeRanges =
					_app != 'Phone' ? getTimeRanges(_date, _section, 'Phone', false, true, true) : timeRanges
				if (sectionTimeRanges && timeRanges) {
					var capacityGroupsFreeSeats =
						!_type || _type == 'Regular'
							? hashCapacityGroupsByTimeRanges(_section, sectionTimeRanges.timeRanges)
							: null
					return {
						appLabel: appLabel,
						app: _app,
						timeRanges: timeRanges,
						sectionTimeRanges: sectionTimeRanges,
						capacityGroupsFreeSeats: capacityGroupsFreeSeats,
					}
				}
			}

			return null
		}

		function dayRangeOptions(
			_startDate,
			_endDate,
			_app,
			_type,
			_bypassBlocks,
			_bypassAntecedence,
			_callback
		) {
			if (!moment.isMoment(_startDate)) {
				_startDate = moment.tz(_startDate, dbDateTz)
			}
			if (!moment.isMoment(_endDate)) {
				_endDate = moment.tz(_endDate, dbDateTz)
			}

			var daysTimeRanges = {}
			var iDate = moment(_startDate)
			while (iDate.isBefore(_endDate, 'day') || iDate.isSame(_endDate, 'day')) {
				_.map(sectionsObj, function (sectionObj, section) {
					var sectionDayTimeRanges = getSectionDayTimeRanges(
						section,
						iDate,
						_app,
						_type,
						_bypassBlocks,
						_bypassAntecedence
					)
					if (sectionDayTimeRanges) {
						if (!daysTimeRanges[iDate.format('YYYY-MM-DD')]) {
							daysTimeRanges[iDate.format('YYYY-MM-DD')] = {}
						}
						daysTimeRanges[iDate.format('YYYY-MM-DD')][section] = sectionDayTimeRanges
					}
				})

				iDate.add(1, 'days')
			}

			getNewStatus({ startDate: _startDate, endDate: _endDate }, function (error, _status) {
				if (error) {
					return _callback(error, null)
				}

				if (_status && _status.length > 0) {
					_.map(_status, function (timestampUsage) {
						var day = moment.tz(timestampUsage._id.day, dbDateTz).format('YYYY-MM-DD')
						var sectionsTimeRanges = daysTimeRanges[day]
						if (sectionsTimeRanges) {
							if (timestampUsage.sectionusage && timestampUsage.sectionusage.length > 0) {
								_.map(timestampUsage.sectionusage, function (sectionUsage) {
									if (sectionUsage.partyusage && sectionUsage.partyusage.length > 0) {
										_.map(sectionUsage.partyusage, function (usage) {
											var loopCapacityGroup = findCapacityGroup(sectionUsage.section, usage.partySize)
											if (sectionsTimeRanges[sectionUsage.section]) {
												updateFreeSeatsPerspectives(
													sectionsTimeRanges[sectionUsage.section].sectionTimeRanges.timeRangesSeats,
													sectionsTimeRanges[sectionUsage.section].sectionTimeRanges.timeRangesOptions,
													sectionsTimeRanges[sectionUsage.section].timeRanges.timeRangesSeats,
													sectionsTimeRanges[sectionUsage.section].timeRanges.timeRangesOptions,
													sectionsTimeRanges[sectionUsage.section].capacityGroupsFreeSeats,
													sectionsTimeRanges[sectionUsage.section].sectionTimeRanges.timeRangesOptions,
													usage,
													loopCapacityGroup,
													sectionsTimeRanges[sectionUsage.section].appLabel,
													_app
												)
											}
										})
									}
								})
							}
						}
					})
				}

				return _callback(false, _.orderBy(getUpdatedDayRangeOptions(daysTimeRanges), ['day']))
			})
		}

		function sectionOptions(_date, _app, _type, _bypassBlocks, _bypassAntecedence, _callback) {
			if (!moment.isMoment(_date)) {
				_date = moment.tz(_date, dbDateTz)
			}

			var sectionsTimeRanges = {}
			_.map(sectionsObj, function (sectionObj, section) {
				var sectionDayTimeRanges = getSectionDayTimeRanges(
					section,
					_date,
					_app,
					_type,
					_bypassBlocks,
					_bypassAntecedence
				)
				if (sectionDayTimeRanges) {
					sectionsTimeRanges[section] = sectionDayTimeRanges
				}
			})

			var queryData = { date: _date }
			getNewStatus(queryData, function (error, _status) {
				if (error) {
					return _callback(error, null)
				}

				if (_status && _status.length > 0) {
					_.map(_status, function (timestampUsage) {
						if (timestampUsage.sectionusage && timestampUsage.sectionusage.length > 0) {
							_.map(timestampUsage.sectionusage, function (sectionUsage) {
								if (sectionUsage.partyusage && sectionUsage.partyusage.length > 0) {
									_.map(sectionUsage.partyusage, function (usage) {
										var loopCapacityGroup = findCapacityGroup(sectionUsage.section, usage.partySize)
										if (sectionsTimeRanges[sectionUsage.section]) {
											updateFreeSeatsPerspectives(
												sectionsTimeRanges[sectionUsage.section].sectionTimeRanges.timeRangesSeats,
												sectionsTimeRanges[sectionUsage.section].sectionTimeRanges.timeRangesOptions,
												sectionsTimeRanges[sectionUsage.section].timeRanges.timeRangesSeats,
												sectionsTimeRanges[sectionUsage.section].timeRanges.timeRangesOptions,
												sectionsTimeRanges[sectionUsage.section].capacityGroupsFreeSeats,
												sectionsTimeRanges[sectionUsage.section].sectionTimeRanges.timeRangesOptions,
												usage,
												loopCapacityGroup,
												sectionsTimeRanges[sectionUsage.section].appLabel,
												_app
											)
										}
									})
								}
							})
						}
					})
				}

				return _callback(false, _.orderBy(getUpdatedSectionOptions(sectionsTimeRanges, _type), ['label']))
			})
		}

		function getUpdatedTimeOptions(
			_timeOptions,
			_sectionTimeRangesFreeSeats,
			_timeRangesFreeSeats,
			_capacityGroupsFreeSeats,
			_capacityGroup,
			_isBookingApp,
			_partySize,
			_date,
			_section,
			_app,
			_type
		) {
			return _.map(_timeOptions, function (timeOption) {
				var freeTablesBySection = Math.floor(
					_sectionTimeRangesFreeSeats[timeOption.scheduleId] /
						(_capacityGroup ? _capacityGroup.max : _partySize)
				)
				var freeTablesPerspectives = [freeTablesBySection]
				if ((_app != 'Phone' && !_isBookingApp) || _isBookingApp) {
					var freeTablesByApp = Math.floor(
						_timeRangesFreeSeats[timeOption.scheduleId] / (_capacityGroup ? _capacityGroup.max : _partySize)
					)
					freeTablesPerspectives.push(freeTablesByApp)
				}

				//For group reservations, the capacity groups seats are not considered
				if (!_type || _type == 'Regular') {
					if (_capacityGroupsFreeSeats && _.size(_capacityGroupsFreeSeats) > 0) {
						var freeTablesByGroup = _capacityGroupsFreeSeats[_capacityGroup._id][timeOption.scheduleId]
						freeTablesPerspectives.push(freeTablesByGroup)
					} else {
						//No capacity groups set for this section
						freeTablesPerspectives.push(0)
					}
				}

				var freeTables = Math.min.apply(Math, freeTablesPerspectives)
				return {
					value: timeOption.time,
					freeTables: freeTables,
					time: timeOption.time,
					blocked:
						isTimestampBlocked(_date, _section, timeOption.time) &&
						!isTimestampOnExtraSchedules(_date, _section, timeOption.time, _app),
					respectsAntecedence: isTimestampRespectingAntecedence(_date, timeOption.time),
				}
			})
		}

		function timeReservationLimit(
			_date,
			_app,
			_section,
			_partySize,
			_type,
			_bypassBlocks,
			_bypassAntecedence,
			_callback
		) {
			if (!moment.isMoment(_date)) {
				_date = moment.tz(_date, dbDateTz)
			}

			var isBookingApp = _.has(sectionsObj[_section], _app) ? true : false
			var appLabel = isBookingApp ? findAppLabel(_app) : null
			var timeRanges = getTimeRanges(_date, _section, _app, isBookingApp, _bypassBlocks, _bypassAntecedence)
			var sectionTimeRanges =
				_app != 'Phone' ? getTimeRanges(_date, _section, 'Phone', false, true, true) : timeRanges
			var capacityGroup = findCapacityGroup(_section, _partySize)

			var queryData = { date: _date, section: _section }
			getNewStatus(queryData, function (error, _status) {
				if (error) {
					return _callback(error, null)
				}

				var sectionTimeRangesFreeSeats = sectionTimeRanges.timeRangesSeats
				var timeRangesFreeSeats = _app != 'Phone' ? timeRanges.timeRangesSeats : null
				var capacityGroupsFreeSeats =
					!_type || _type == 'Regular'
						? hashCapacityGroupsByTimeRanges(_section, sectionTimeRanges.timeRanges)
						: null

				if (_status && _status.length > 0) {
					_.map(_status, function (timestampUsage) {
						if (timestampUsage.sectionusage && timestampUsage.sectionusage.length > 0) {
							_.map(timestampUsage.sectionusage, function (sectionUsage) {
								if (sectionUsage.partyusage && sectionUsage.partyusage.length > 0) {
									_.map(sectionUsage.partyusage, function (usage) {
										var loopCapacityGroup = findCapacityGroup(sectionUsage.section, usage.partySize)
										updateFreeSeatsPerspectives(
											sectionTimeRangesFreeSeats,
											sectionTimeRanges.timeRangesOptions,
											timeRangesFreeSeats,
											timeRanges.timeRangesOptions,
											capacityGroupsFreeSeats,
											sectionTimeRanges.timeRangesOptions,
											usage,
											loopCapacityGroup,
											appLabel,
											_app
										)
									})
								}
							})
						}
					})
				}

				var timeOptions = getUpdatedTimeOptions(
					timeRanges.timeRangesOptions,
					sectionTimeRangesFreeSeats,
					timeRangesFreeSeats,
					capacityGroupsFreeSeats,
					capacityGroup,
					isBookingApp,
					_partySize,
					_date,
					_section,
					_app,
					_type
				)

				_callback(false, _.orderBy(timeOptions, ['value']))
			})
		}

		/**
		 * END: Shared code between all apps
		 */

		/**
		 * START: Widget app specific code
		 */

		function getBooking(_queryData, _callback) {
			dataFactory
				.getBooking(_queryData)
				.then(function (reservationStatus) {
					_callback(false, reservationStatus.data)
				})
				.catch(function (response) {
					_callback(response, null)
				})
		}

		function getNow() {
			return tgClock.getClock().now
		}

		return {
			setReservationSettings: function (_settings) {
				reservationSettings = _.cloneDeep(_settings)
				startReservationSettings(reservationSettings)
				return reservationSettings
			},
			getSectionObj: function (_id) {
				return getSectionById(_id)
			},
			getAppLabel: function (_id) {
				return findAppLabel(_id)
			},
			getReservationSettings: function (key) {
				if (!!key) {
					return _.get(reservationSettings, key)
				} else {
					return reservationSettings
				}
			},
			getReservationSectionOptions: function (
				_date,
				_app,
				_type,
				_bypassBlocks,
				_bypassAntecedence,
				_callback
			) {
				sectionOptions(_date, _app, _type, _bypassBlocks, _bypassAntecedence, function (error, _options) {
					_callback(error, _options)
				})
			},
			getReservationDayRangeOptions: function (
				_startDate,
				_endDate,
				_app,
				_type,
				_bypassBlocks,
				_bypassAntecedence,
				_callback
			) {
				dayRangeOptions(_startDate, _endDate, _app, _type, _bypassBlocks, _bypassAntecedence, function (
					error,
					_options
				) {
					_callback(error, _options)
				})
			},
			getReservationAppsOptions: function () {
				return appsOptions()
			},
			getSectionReservationLimit: function (_date, _app, _section, _callback) {
				sectionReservationLimit(_date, _app, _section, function (error, _options) {
					_callback(error, _options)
				})
			},
			getSectionTimeRange: function (
				_date,
				_app,
				_section,
				_partySize,
				_type,
				_bypassBlocks,
				_bypassAntecedence,
				_callback
			) {
				timeReservationLimit(
					_date,
					_app,
					_.toString(_section),
					_.toInteger(_partySize),
					_type,
					_bypassBlocks,
					_bypassAntecedence,
					function (error, _options) {
						_callback(error, _options)
					}
				)
			},
		}

		/**
		 * END: Widget app specific code
		 */
	})
